import { toast } from "sonner";

/**
 * Show a celebratory toast for every newly-unlocked badge returned by
 * POST /api/attempts. Staggered so each one is readable.
 */
export function showBadgeUnlocks(newBadges) {
  if (!Array.isArray(newBadges) || newBadges.length === 0) return;
  newBadges.forEach((b, idx) => {
    setTimeout(() => {
      toast.success(`Badge unlocked: ${b.title}`, {
        description: b.desc,
        duration: 5000,
      });
    }, idx * 900);
  });
}

/**
 * If the attempt added N sentences to the user's mistake queue, surface a
 * gentle nudge toast with a "Drill now" action.
 */
export function showMistakesAddedToast(count) {
  if (!count || count < 1) return;
  toast(`${count} sentence${count === 1 ? "" : "s"} added to your Mistake Practice`, {
    description: "Drill them at any time to lock in the fixes.",
    action: {
      label: "Drill now",
      onClick: () => { window.location.href = "/mistakes"; },
    },
    duration: 6500,
  });
}
